// extracted by mini-css-extract-plugin
export default {"survey_list":"index_survey_list_OmvlO","item":"index_item_s2fcZ","option":"index_option_DrR8Y","label":"index_label_ZhHbN","title":"index_title_fDf7h","input":"index_input_iSYNa"};